import axios from 'axios';

// Create an instance of axios
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL, // Use environment variable for backend URL
});

/*
  NOTE: interceptors are used to run code before a request is sent or after a response is received.
  Here, we're setting the x-auth-token header on every request if a token exists in localStorage.
*/
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }

    // Set Content-Type to application/json only if not FormData
    // FormData will automatically set the correct Content-Type with boundary
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    // Add ngrok header only if using ngrok URL
    if (config.baseURL && config.baseURL.includes('ngrok')) {
      config.headers['ngrok-skip-browser-warning'] = 'true';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
